/** @namespace */
// eslint-disable-next-line no-use-before-define,no-var
var ripe = typeof ripe === "undefined" ? {} : ripe;

if (typeof module !== "undefined") {
    module.exports = {
        ripe: ripe
    };
}
